/* Buy Bathroom Supplies — theme.js
   Lightweight vanilla JS. No frameworks. */

(function () {
  'use strict';

  /* ----- Header scroll state ---------------------------------------- */
  const header = document.querySelector('.site-header');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 8);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ----- Mobile drawer ---------------------------------------------- */
  const drawer = document.querySelector('.drawer');
  const openBtn = document.querySelector('.menu-toggle');
  const closeBtn = document.querySelector('.drawer__close');
  if (drawer && openBtn) {
    openBtn.addEventListener('click', () => {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  }

  /* ----- Scroll reveal --------------------------------------------- */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-visible'));
  }

  /* ----- Product gallery ------------------------------------------- */
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main] img');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----- Quantity selector ----------------------------------------- */
  document.querySelectorAll('[data-qty]').forEach(wrap => {
    const input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.action === 'plus' ? 1 : -1;
        const min = parseInt(input.min || '1', 10);
        const next = Math.max(min, parseInt(input.value || '1', 10) + dir);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ----- Variant picker (basic, single-variant or simple option) --- */
  const variantForm = document.querySelector('[data-product-form]');
  if (variantForm) {
    const variantData = (() => {
      const tag = document.querySelector('[data-product-json]');
      if (!tag) return null;
      try { return JSON.parse(tag.textContent); } catch (e) { return null; }
    })();

    const optionInputs = variantForm.querySelectorAll('[data-option-input]');
    const variantIdInput = variantForm.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const addBtn = variantForm.querySelector('[data-add-to-cart]');

    const onChange = () => {
      if (!variantData) return;
      const selected = [];
      optionInputs.forEach(group => {
        const active = group.querySelector('.is-active');
        if (active) selected.push(active.dataset.value);
      });
      const match = variantData.variants.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      );
      if (match) {
        if (variantIdInput) variantIdInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to basket' : 'Sold out';
        }
      }
    };

    document.querySelectorAll('.product-option__value').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-option-input]');
        if (!group) return;
        group.querySelectorAll('.product-option__value').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        onChange();
      });
    });
  }

  /* ----- Money formatter ------------------------------------------- */
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'GBP';
    const symbol = currency === 'GBP' ? '£' : currency === 'EUR' ? '€' : '$';
    return symbol + value;
  }

  /* ----- Cart count updater (after AJAX add) ----------------------- */
  window.updateCartCount = function (count) {
    const el = document.querySelector('[data-cart-count]');
    if (!el) return;
    if (count > 0) {
      el.textContent = count;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  };

  /* ----- AJAX add to cart ------------------------------------------ */
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      // Allow standard form submission if JS-add is disabled
      if (!form.hasAttribute('data-ajax')) return;
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('Add to cart failed');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        if (window.updateCartCount) window.updateCartCount(cart.item_count);
        if (btn) btn.textContent = 'Added ✓';
        setTimeout(() => { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1500);
      } catch (err) {
        if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
        console.error(err);
      }
    });
  });
})();
